// src/components/results/mapLCW.js
import React, {
  useMemo, useState, useCallback, useContext, useEffect, useRef
} from "react";
import { GoogleMap, Marker, InfoWindow, useLoadScript } from "@react-google-maps/api";
import AuthContext from "../../Context/AuthContext";

export default function MobilityMap({
  rawData = [],
  centerFallback = { lat: 41.04, lng: 28.99 },
  zoom = 12,
}) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  const { userData } = useContext(AuthContext);

  const sestoColor = {
    "A": "red",
    "B": "blue",
    "C": "purple",
    "Bağdat Caddesi": "green",
    "Kent Vizyon": "yellow",
    "Panout Otobüs Durağı": "orange",
    "Urban CLP": "pink",
    "Urban Metrobus": "red",
    "YOVI Megalight": "blue",
    "YOVI ONTV": "pink",
    
  };

  const STORE_SVG_DATA_URL = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <defs>
        <clipPath id="circleClip">
          <circle cx="20" cy="20" r="18"/>
        </clipPath>
      </defs>
      <circle cx="20" cy="20" r="18" fill="white" stroke="#ddd" stroke-width="1"/>
      <image x="2" y="2" width="36" height="36" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAXVBMVEUAgoYAgIQAfYEAgYVCnaBkrbAhjZGo0dL////7/v7d7e2JwsOv1tf0+flztbeizc7r9fVRpKcMiIs9mJwCiIwKj5MwlJfE4eLN5ufB4OHY7OyUxsgzmp1cqKrM5eZfJg/dAAAAtklEQVR4AcXQRQKEQAwAwQju7vD/Z26G4HDfuiANY/A/SCfke2PLPlnOPbPrnfwgJL7HmwguFSXGiUoz+TnHe8wKUonveSEdjTUiG1TGt1hVJtbVqonkvkRQXLRBbBapMmk2H4NC5t11FvER+8H8OShz740mqqJY5yzU1MuXNn2ulqmRadLLXjSqNUZ0P4SpUXMrk4a3P6VufLkfHLz+edOVBAcOu+XQRjYhXFTFoaoY4Yav4J9+FmkPI9dC0nMAAAAASUVORK5CYII=" clip-path="url(#circleClip)"/>
    </svg>
  `);

  const WEDDING_HALL_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-label="Düğün salonu">
  <path d="M3 10l9-6 9 6"/>
  <path d="M5 10v10h14V10"/>
  <rect x="9" y="14" width="6" height="6" rx="1"/>
  <path d="M12 9.6c-.9-1.2-3-1-3 .9 0 1.2 1.2 2.3 3 3 1.8-.7 3-1.8 3-3 0-1.9-2.1-2.1-3-.9z" fill="currentColor" stroke="none"/>
</svg>

    `);

  const MARRIAGE_HALL_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 435.729 435.729" xml:space="preserve">
<g>
	<path d="M175.622,47.125c0-26.027-21.473-47.125-47.5-47.125s-47.5,21.099-47.5,47.125v24.333h95V47.125z"/>
	<circle cx="338.583" cy="35.494" r="35.494"/>
	<polygon points="353.743,101.729 353.743,141.729 323.743,141.729 323.743,101.729 265.743,101.729 265.743,269.729    284.743,269.729 284.743,435.729 392.743,435.729 392.743,269.729 411.743,269.729 411.743,101.729  "/>
	<polygon points="172.26,191.729 184.435,101.729 72.264,101.729 84.44,191.729  "/>
	<polygon points="82.345,221.729 23.986,435.729 232.714,435.729 174.354,221.729  "/>
</g>
</svg>
    `);

  const REAL_ESTATE_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M256,1.468L0,254.587h39.984v255.945h432.033V254.587H512L256,1.468z M441.78,480.294H70.221V227.679L256,43.99    l185.78,183.689V480.294z"/>
	</g>
</g>
<g>
	<g>
		<path d="M346.318,217.594C346.318,217.594,346.318,217.594,346.318,217.594c-6.617-6.619-15.415-10.263-24.772-10.263    c-9.358,0-18.156,3.645-24.772,10.262c-13.659,13.658-13.659,35.883,0,49.543c6.83,6.83,15.801,10.244,24.771,10.244    c8.972,0,17.943-3.415,24.772-10.244C359.977,253.477,359.977,231.252,346.318,217.594z M324.937,245.755    c-1.869,1.869-4.912,1.871-6.782,0c-1.869-1.87-1.869-4.911,0.001-6.782c1.222-1.222,2.649-1.404,3.391-1.404    c0.742,0,2.169,0.182,3.39,1.403l0.001,0.001C326.805,240.843,326.805,243.885,324.937,245.755z"/>
	</g>
</g>
<g>
	<g>
		<path d="M372.925,190.986c-16.541-16.541-38.531-25.649-61.923-25.649c-23.391,0-45.382,9.108-61.922,25.649    c-23.247,23.245-31.305,57.68-21.525,88.51L112.099,394.953l8.586,41.855l31.637,31.637l132.092-132.091    c30.827,9.778,65.264,1.72,88.51-21.525C407.069,280.686,407.069,225.13,372.925,190.986z M351.544,293.449    c-16.907,16.905-42.848,21.544-64.551,11.543l-9.568-4.41L152.323,425.684l-3.841-3.841l-3.491-17.02l118.338-118.337l-4.41-9.568    c-10.001-21.705-5.363-47.647,11.543-64.551c10.829-10.829,25.228-16.793,40.541-16.793c15.315,0,29.713,5.964,40.542,16.793    C373.899,234.72,373.899,271.093,351.544,293.449z"/>
	</g>
</g>
</svg>
    `);
  const FIZIK_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="800px" height="800px" viewBox="0 0 64 64" aria-hidden="true" role="img" class="iconify iconify--medical-icon" preserveAspectRatio="xMidYMid meet"><path d="M30.827 19.223a5.887 5.887 0 0 0 5.892-5.881a5.884 5.884 0 0 0-5.892-5.879c-3.255 0-5.893 2.632-5.893 5.879a5.889 5.889 0 0 0 5.893 5.881z" fill="#000000"/><path d="M48.78 58.98H1.806c-1.323 0-1.187 1.04-1.187 1.04v1.731S.499 64 2.809 64h58.817c2.325 0 2.199-2.197 2.199-2.197v-4.794s-.197-1.516-1.98-1.516h-5.732c-1.965 0-3.589 3.486-7.332 3.486z" fill="#000000"/><path d="M53.348 48.358c0 2.922 2.378 5.295 5.308 5.295c2.929 0 5.313-2.374 5.313-5.295c0-2.933-2.384-5.297-5.313-5.297a5.298 5.298 0 0 0-5.308 5.297z" fill="#000000"/><path d="M35.997 38.255a3.77 3.77 0 0 1-2.269 2.36l-4.727 1.753l1.744 1.731h7.98l-.005-12.215l-2.671 6.297c-.013.03-.037.047-.053.074z" fill="#000000"/><path d="M47.458 47.001h-16.5l-3.978-3.884l-2.769 1.02c-2.054.735-4.555-.387-5.326-2.428c-.454-1.267-.391-2.682.367-3.713c-.339-.015-10.007 0-10.007 0a2.906 2.906 0 0 0-2.915 2.898c0 1.607 1.307 2.863 2.915 2.863h9.843l3.903 5.909L2.84 51.285a2.909 2.909 0 0 0 .651 5.745l22.609.003a4.133 4.133 0 0 1-.629-2.177a4.176 4.176 0 0 1 4.173-4.173h9.046l7.331-1.531l.407 1.947l-7.533 1.573h-9.252a2.18 2.18 0 0 0-.044 4.361l17.898.002a5.014 5.014 0 0 0 4.992-5.013A5.023 5.023 0 0 0 47.458 47z" fill="#000000"/><path d="M23.862 42.315a2.309 2.309 0 0 1-3.038-1.185a2.303 2.303 0 0 1 1.187-3.04l8.401-3.154l2.596-6.192l-1.692-.625l-2.207 5.302l-6.395 2.355v-6.482l-6.251 6.827l-7.074-.007s12.379-13.57 12.766-13.976c.513-.509 1.686-1.353 3.898-1.353h7.949c4.516 0 5.385 4.502 4.461 6.832l-4.157 10.082a2.344 2.344 0 0 1-1.338 1.261l-9.106 3.353z" fill="#000000"/></svg>
    `);

  const UNIVERSITY_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 16 16"><path d="M16 6.28a1.23 1.23 0 0 0-.62-1.07l-6.74-4a1.27 1.27 0 0 0-1.28 0l-6.75 4a1.25 1.25 0 0 0 0 2.15l1.92 1.12v2.81a1.28 1.28 0 0 0 .62 1.09l4.25 2.45a1.28 1.28 0 0 0 1.24 0l4.25-2.45a1.28 1.28 0 0 0 .62-1.09V8.45l1.24-.73v2.72H16V6.28zm-3.73 5L8 13.74l-4.22-2.45V9.22l3.58 2.13a1.29 1.29 0 0 0 1.28 0l3.62-2.16zM8 10.27l-6.75-4L8 2.26l6.75 4z"/></svg>
    `);

  const COMPETITOR_SVG_DATA_URL =
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
     <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
        <path fill="#555" d="M3 9h18v13H3z"/>
        <path fill="#777" d="M2 8l2-4h16l2 4z"/>
        <rect x="8" y="13" width="8" height="9" fill="#999"/>
        <rect x="10" y="15" width="4" height="4" fill="#555"/>
      </svg>
      `);

  // LCW.JSON kategorileri için custom SVG ikonlar
  const BAGDAT_CADDESI_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#00CED1" stroke="white" stroke-width="2"/>
      <path d="M16 8v16M8 16h16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  `);

  const KENT_VIZYON_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF1493" stroke="white" stroke-width="2"/>
      <rect x="10" y="10" width="12" height="12" fill="white" rx="2"/>
      <circle cx="16" cy="16" r="3" fill="#FF1493"/>
    </svg>
  `);

  const PANOUT_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#1E90FF" stroke="white" stroke-width="2"/>
      <rect x="8" y="10" width="16" height="12" rx="2" fill="white"/>
      <circle cx="12" cy="22" r="2" fill="#1E90FF"/>
      <circle cx="20" cy="22" r="2" fill="#1E90FF"/>
    </svg>
  `);

  const URBAN_CLP_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#32CD32" stroke="white" stroke-width="2"/>
      <rect x="9" y="9" width="14" height="14" fill="white" rx="1"/>
      <path d="M13 16h6M16 13v6" stroke="#32CD32" stroke-width="1.5"/>
    </svg>
  `);

  const URBAN_METROBUS_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FFD700" stroke="white" stroke-width="2"/>
      <rect x="8" y="10" width="16" height="12" rx="2" fill="white"/>
      <rect x="10" y="12" width="3" height="3" fill="#FFD700"/>
      <rect x="14" y="12" width="3" height="3" fill="#FFD700"/>
      <rect x="18" y="12" width="3" height="3" fill="#FFD700"/>
      <circle cx="11" cy="23" r="1.5" fill="#FFD700"/>
      <circle cx="21" cy="23" r="1.5" fill="#FFD700"/>
    </svg>
  `);

  const YOVI_MEGALIGHT_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF4500" stroke="white" stroke-width="2"/>
      <polygon points="16,9 20,15 18,15 22,22 14,22 18,15 16,15" fill="white"/>
    </svg>
  `);

  const YOVI_ONTV_SVG = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(`
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#FF69B4" stroke="white" stroke-width="2"/>
      <rect x="10" y="10" width="12" height="11" fill="white" rx="1"/>
      <polygon points="16,22 14,25 18,25" fill="#FF69B4"/>
    </svg>
  `);

  // ---- Noktalar
  const points = useMemo(() => {
    const norm = (v) => (typeof v === "string" ? v.replace(/\s+/g, " ").trim() : v) || null;
    return (Array.isArray(rawData) ? rawData : [])
      .map((r, idx) => {
        const lat = Number(String(r.latitude).replace(",", "."));
        const lng = Number(String(r.longitude).replace(",", "."));
        const type = norm(r["Liste Tür"] ?? r["Liste  Tür"] ?? null);
        const ses = norm(r["SES"]) || type || (type === "Mağaza" ? "Mağaza" : "Diğer");
        const colorName = (ses && sestoColor[ses]) || "red";
        return {
          id: `p${idx + 1}`,
          lat: Number.isFinite(lat) ? lat : null,
          lng: Number.isFinite(lng) ? lng : null,
          title: r["Adres"] || type || `Konum #${idx + 1}`,
          address: r["Adres"] || null,
          type,
          ses,
          colorName,
          raw: r,
        };
      })
      .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng));
  }, [rawData]);

  // ---- Başlangıç merkezi
  const initialCenter = useMemo(() => {
    if (!points.length) return centerFallback;
    const sum = points.reduce((acc, p) => ({ lat: acc.lat + p.lat, lng: acc.lng + p.lng }), { lat: 0, lng: 0 });
    return { lat: sum.lat / points.length, lng: sum.lng / points.length };
  }, [points, centerFallback]);

  // ---- Controlled center: sadece ilk kez set et
  const [mapCenter, setMapCenter] = useState(initialCenter);
  const [didCenterOnce, setDidCenterOnce] = useState(false);
  const mapRef = useRef(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!didCenterOnce) {
      setMapCenter(initialCenter);
      setDidCenterOnce(true);
    }
  }, [initialCenter, didCenterOnce]);

  const onLoad = useCallback((map) => (mapRef.current = map), []);
  const onDragEnd = useCallback(() => {
    if (mapRef.current) setMapCenter(mapRef.current.getCenter().toJSON());
  }, []);

  // ---- Legend + Filtre (SES bazlı)
  const allSES = useMemo(
    () => Array.from(new Set(points.map((p) => p.ses).filter(Boolean))).sort(),
    [points]
  );
  const [visibleSES, setVisibleSES] = useState(() => new Set(allSES)); // hepsi açık başla

  // allSES değişirse (data güncellenirse) görünürlüğü senkronla
  useEffect(() => {
    setVisibleSES((prev) => {
      const next = new Set(prev);
      allSES.forEach((t) => next.add(t));
      // var olmayanları çıkar
      for (const t of Array.from(next)) if (!allSES.includes(t)) next.delete(t);
      return next;
    });
  }, [allSES]);

  const toggleSES = (t) =>
    setVisibleSES((s) => {
      const n = new Set(s);
      n.has(t) ? n.delete(t) : n.add(t);
      return n;
    });

  const setAll = (on) => setVisibleSES(new Set(on ? allSES : []));

  // Legend sırası: A,B,C -> Bellona -> LCW
  const legendOrder = [
    "A", "B", "C",
    "Mağaza", "Düğün Salonu", "Nikah Salonu", "Emlak Ofisi", "Üniversite", "Fizik Tedavi Merkezi", "Rakip Mağazalar",
    "Bağdat Caddesi", "Kent Vizyon", "Panout Otobüs Durağı", "Urban CLP", "Urban Metrobus", "YOVI Megalight", "YOVI ONTV"
  ];

  const labelDisplayMap = {
    "Mağaza": "Bellona Mağazaları",
    "Panout Otobüs Durağı": "Panout Otobüs Durağı",
    "Urban CLP": "Urban CLP",
    "Bağdat Caddesi": "Bağdat Caddesi",
    "Kent Vizyon": "Kent Vizyon",
    "Urban Metrobus": "Urban Metrobus",
    "YOVI Megalight": "YOVI Megalight",
    "YOVI ONTV": "YOVI ONTV"
  };

  const legendItems = useMemo(
    () => {
      // allSES'i legendOrder'a göre sırala
      const sortedSES = legendOrder.filter(item => allSES.includes(item));

      return sortedSES.map((label) => {
        const color = sestoColor[label] || "red";
        let iconSrc;
        switch (label) {
          case "Mağaza":
            iconSrc = STORE_SVG_DATA_URL;
            break;
          case "Düğün Salonu":
            iconSrc = WEDDING_HALL_SVG_DATA_URL;
            break;
          case "Nikah Salonu":
            iconSrc = MARRIAGE_HALL_SVG_DATA_URL;
            break;
          case "Emlak Ofisi":
            iconSrc = REAL_ESTATE_SVG_DATA_URL;
            break;
          case "Üniversite":
            iconSrc = UNIVERSITY_SVG_DATA_URL;
            break;
          case "Fizik Tedavi Merkezi":
            iconSrc = FIZIK_SVG_DATA_URL;
            break;
          case "Rakip Mağazalar":
            iconSrc = COMPETITOR_SVG_DATA_URL;
            break;
          case "Urban Metrobus":
          case "YOVI Megalight":
          case "YOVI ONTV":
            // Renk noktaları
            iconSrc = `https://maps.google.com/mapfiles/ms/icons/${color}-dot.png`;
            break;

          default:
            // A, B, C için Google Maps renkli noktaları
            iconSrc = `https://maps.google.com/mapfiles/ms/icons/${color}-dot.png`;
        }
        const displayLabel = labelDisplayMap[label] || label;
        return { label, displayLabel, iconSrc, checked: visibleSES.has(label) };
      });
    },
    [allSES, visibleSES, legendOrder]
  );

  if (loadError) return <div style={{ padding: 12, color: "#b00020" }}>Harita yüklenirken hata: {String(loadError.message || loadError)}</div>;
  if (!isLoaded) return <div>Harita yükleniyor…</div>;

  // ---- InfoWindow stilleri
  const cardStyle = { maxWidth: 260, display: "grid", gap: 8, fontFamily: "system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif" };
  const titleStyle = { margin: 0, fontSize: 16, fontWeight: 600 };
  const metaStyle = { margin: 0, fontSize: 13, lineHeight: 1.4, opacity: 0.9 };
  const infoOpts = { maxWidth: 280, pixelOffset: new window.google.maps.Size(0, -8) };

  const getMarkerIcon = (colorName, ses) => {
    let iconUrl;
    switch (ses) {
      case "Mağaza":
        iconUrl = STORE_SVG_DATA_URL;
        break;
      case "Düğün Salonu":
        iconUrl = WEDDING_HALL_SVG_DATA_URL;
        break;
      case "Nikah Salonu":
        iconUrl = MARRIAGE_HALL_SVG_DATA_URL;
        break;
      case "Emlak Ofisi":
        iconUrl = REAL_ESTATE_SVG_DATA_URL;
        break;
      case "Üniversite":
        iconUrl = UNIVERSITY_SVG_DATA_URL;
        break;
      case "Fizik Tedavi Merkezi":
        iconUrl = FIZIK_SVG_DATA_URL;
        break;
      case "Rakip Mağazalar":
        iconUrl = COMPETITOR_SVG_DATA_URL;
        break;
      case "Urban Metrobus":
      case "YOVI Megalight":
      case "YOVI ONTV":
        // Renk noktaları
        return `https://maps.google.com/mapfiles/ms/icons/${colorName}-dot.png`;
      default:
        // A, B, C için Google Maps renkli noktaları kullan
        return `https://maps.google.com/mapfiles/ms/icons/${colorName}-dot.png`;
    }
    return { url: iconUrl, scaledSize: new window.google.maps.Size(32, 32), anchor: new window.google.maps.Point(16, 32) };
  };

  // ---- Filtre uygulanmış noktalar
  const visiblePoints = points.filter((p) => !p.ses || visibleSES.has(p.ses));

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <div
        style={{
          height: "800px",
          width: "80%",
          margin: "40px auto",
          borderRadius: 8,
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0,0,0,.2)",
          position: "relative",
        }}
      >
        <GoogleMap
          center={mapCenter}
          zoom={zoom}
          onLoad={onLoad}
          onDragEnd={onDragEnd}
          mapContainerStyle={{ height: "100%", width: "100%" }}
          options={{ gestureHandling: "greedy" }}
        >
          {visiblePoints.map((p) => (
            <Marker
              key={p.id}
              position={{ lat: p.lat, lng: p.lng }}
              onClick={() => setActive(p)}
              icon={getMarkerIcon(p.colorName, p.ses)}
            />
          ))}

          {active && (
            <InfoWindow position={{ lat: active.lat, lng: active.lng }} onCloseClick={() => setActive(null)} options={infoOpts}>
              <div style={cardStyle}>
                <h3 style={titleStyle}>{active.raw["İsim"] || active.title}</h3>
                {active.address && (
                  <p style={metaStyle}>
                    <strong>Adres:</strong> {active.address}
                  </p>
                )}
                {active.raw["POI Tipi"] && (
                  <p style={metaStyle}>
                    <strong>POI Tipi:</strong> {active.raw["POI Tipi"]}
                  </p>
                )}
                {active.type && (
                  <p style={metaStyle}>
                    <strong>Liste Tür:</strong> {active.type}
                  </p>
                )}
                {active.ses && (
                  <p style={metaStyle}>
                    <strong>SES:</strong> {active.ses}
                  </p>
                )}
              </div>
            </InfoWindow>
          )}
        </GoogleMap>

        {/* Legend + Filtre */}
        <div
          style={{
            position: "absolute",
            left: 12,
            bottom: 12,
            background: "rgba(255,255,255,.95)",
            padding: "10px 12px",
            borderRadius: 8,
            boxShadow: "0 1px 6px rgba(0,0,0,.2)",
            fontSize: 13,
            minWidth: 210,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            {/* <div style={{ fontWeight: 600 }}>Katman Renkleri</div> */}
            <div style={{ display: "flex", gap: 6 }}>
              <button onClick={() => setAll(true)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Tümünü Aç
              </button>
              <button onClick={() => setAll(false)} style={{ fontSize: 12, padding: "2px 6px", border: "1px solid #ddd", borderRadius: 6, background: "#fff" }}>
                Kapat
              </button>
            </div>
          </div>

          {legendItems.map((it) => (
            <label key={it.label} style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6, cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={it.checked}
                onChange={() => toggleSES(it.label)}
                style={{ margin: 0 }}
              />
              <img alt={it.label} width={18} height={18} src={it.iconSrc} />
              <span>{it.displayLabel}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
